/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import zh from './json/zh.json';
import en from './json/en.json';

export default { en, zh };




// WEBPACK FOOTER //
// ./src/i18n/index.js